module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VHrrrA/tc-custom/9781685506421.jpg?1723407504105",
      "alt": "This image is the cover for the book Dream for Me"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dream for Me\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In a society awake for twenty-four hours a day a man who sleeps is a freak. But not to neurobiologist Shay Mistry. Jacob Garcia, the last known sleeper in America, is the test subject whose brain Shay has been dying to get his hands on for years. When they meet, Shay discovers the sleeper’s brain comes accompanied by a gorgeous body and a hostile attitude. As Jacob sleeps night after night in his lab it’s harder and harder for Shay to resist their mutual attraction."), _c('br'), _c('br'), _vm._v("Jacob is tired of being a lab rat, but he’s got his reasons to be in Shay’s lab -- one of them he’s not going to tell anyone about -- and his plan is to do what he came to do and leave. So falling in love with Shay is like adding a hand grenade to all the other balls he’s juggling. He doesn’t need this added complication, but his desire for Shay is too strong to resist."), _c('br'), _c('br'), _vm._v("When Jacob’s secret comes out, it triggers a chain of events leaving Shay irrevocably changed and forcing Jacob to choose where his loyalties lie.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Becky Black\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0